import CityPageTemplate from "../city-template/CityPageTemplate";
import { claremontConfig } from "./data";

export default function ClaremontPage() {
  return <CityPageTemplate config={claremontConfig} />;
}